export default () => (<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.08333 15L8.08208 13.9425L2.71292 8.25H22V6.75H2.71292L8.08208 1.0575L7.08333 0L0 7.5L7.08333 15Z" fill="white" />
</svg>)
